import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import Button from '@jarvis.oddle/core/components/Button'
import { margin, marginSizes } from '@jarvis.oddle/core/theme/default'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

interface LinkButtonProps {
  href: string
  previewMode: boolean
  children: React.ReactNode
}

const StyledButton = styled(Button)`
  margin-top: ${margin[marginSizes.medium]};
  margin: ${margin[marginSizes.medium]} ${margin[marginSizes.extraSmall]} ${margin[marginSizes.none]};
`

const LinkButton = ({
  href,
  previewMode,
  children
}: LinkButtonProps): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const router = useRouter()
  const link = href?.charAt(0) === '/' ? `/${router.query.locale}${href}` : href
  return (
    <a
      href={link}
      onClick={(e) => {
        if (!previewMode || !href) return
        e.preventDefault()
        window.confirm(
          t(
            'This link cannot be opened in customisation preview. It will be opened in a new window (_target_).\nClick OK to continue',
            { target: href }
          )
        ) && window.open(href, '_blank')
      }}
    >
      <StyledButton>{children}</StyledButton>
    </a>
  )
}

export default LinkButton
